import React from 'react';
import { useTranslation }              from 'react-i18next';

interface CustomCheckboxProps {
    checked: boolean;
    label: string;
    onCheckedChange: (checked: boolean) => void;
    class?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, label, onCheckedChange, class: className = '' }) => {
    const { t } = useTranslation();

    return (
        <label className={"custom-checkbox"}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onCheckedChange(e.target.checked)}
            />
            <span className="checkmark"></span>
            <div className={`checkbox-label ${className}`}>{t(label)}</div>
        </label>
    );
}

export default CustomCheckbox;